module.exports = __webpack_public_path__ + "img/advance_icon.692f8b74.svg";